import React, { useState } from 'react';
import { ArrowLeft, Calendar, Clock, Filter } from 'react-feather';
import { blogPosts, getArticles, getNews } from '../data/blogData';
import './BlogPage.css';

const BlogPage = () => {
  const [filter, setFilter] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');

  // Filter posts based on selection
  const getFilteredPosts = () => {
    let posts = blogPosts;
    
    if (filter === 'articles') {
      posts = getArticles();
    } else if (filter === 'news') {
      posts = getNews();
    }
    
    // Apply search filter
    if (searchQuery) {
      posts = posts.filter(post => 
        post.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (post.excerpt && post.excerpt.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (post.summary && post.summary.toLowerCase().includes(searchQuery.toLowerCase()))
      );
    }
    
    return posts;
  };

  const filteredPosts = getFilteredPosts();

  return (
    <div className="blog-page-container">
      {/* Navigation Header */}
      <nav className="blog-nav">
        <div className="blog-nav-left">
          <button onClick={() => window.location.href = '/'} className="back-btn">
            <ArrowLeft size={20} />
            Back to Home
          </button>
        </div>
        <div className="blog-nav-center">
          <div className="blog-logo">
            <span>Brainy</span>
          </div>
        </div>
        <div className="blog-nav-right"></div>
      </nav>

      {/* Scrollable Content Wrapper */}
      <div className="blog-content-wrapper">
        {/* Search and Filters */}
        <div className="blog-controls">
          <div className="blog-search-container">
            <input 
              type="text" 
              placeholder="Search articles and news..." 
              className="blog-search-input"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          
          <div className="blog-filters">
            <Filter className="filter-icon" size={18} />
            <button 
              className={`filter-btn ${filter === 'all' ? 'active' : ''}`} 
              onClick={() => setFilter('all')}
            >
              All Posts ({blogPosts.length})
            </button>
            <button 
              className={`filter-btn ${filter === 'articles' ? 'active' : ''}`} 
              onClick={() => setFilter('articles')}
            >
              Articles ({getArticles().length})
            </button>
            <button 
              className={`filter-btn ${filter === 'news' ? 'active' : ''}`} 
              onClick={() => setFilter('news')}
            >
              News ({getNews().length})
            </button>
          </div>
        </div>

        {/* Main Content */}
        <div className="blog-main-content">
          {/* Posts Grid */}
          <section className="blog-posts-section">
            <div className="blog-posts-grid">
              {filteredPosts.map((post) => (
                <article 
                  key={post.id} 
                  className={`blog-post-card ${post.type === 'news' ? 'blog-post-news' : 'blog-post-article'}`}
                  onClick={() => window.location.href = `/blog/${post.id}`}
                >
                  {post.type === 'article' ? (
                    <>
                      <div className="blog-post-image-container">
                        <img src={post.image} alt={post.title} className="blog-post-image" />
                        <div className="blog-post-category">{post.category}</div>
                      </div>
                      <div className="blog-post-content">
                        <div className="blog-post-meta">
                          <span className="blog-post-date">
                            <Calendar size={14} />
                            {post.formattedDate}
                          </span>
                          <span className="blog-post-read-time">
                            <Clock size={14} />
                            {post.readTime} min
                          </span>
                        </div>
                        <h3 className="blog-post-title">{post.title}</h3>
                        <p className="blog-post-excerpt">{post.excerpt}</p>
                        <div className="blog-post-author">
                          <img src={post.author.avatar} alt={post.author.name} className="blog-post-author-avatar" />
                          <span className="blog-post-author-name">{post.author.name}</span>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="blog-post-news-content">
                      <div className="blog-post-news-header">
                        <span className="blog-post-news-badge">News</span>
                        <span className="blog-post-news-date">{post.formattedDate}</span>
                      </div>
                      <h3 className="blog-post-news-title">{post.title}</h3>
                      <p className="blog-post-news-summary">{post.summary}</p>
                      <div className="blog-post-news-footer">
                        <Clock size={14} />
                        <span>{post.readTime} min read</span>
                      </div>
                    </div>
                  )}
                </article>
              ))}
            </div>
            
            {filteredPosts.length === 0 && (
              <div className="no-results">
                <p>No posts found matching your search.</p>
              </div>
            )}
          </section>
        </div>

        {/* Footer */}
        <footer className="blog-footer">
          <p>&copy; {new Date().getFullYear()} Brainy AI. All rights reserved.</p>
          <div className="blog-footer-links">
            <a href="/terms">Terms</a>
            <a href="/privacy">Privacy</a>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default BlogPage;

